// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Remove controls (field-row "×" and the tag "Remove tag" trashcan). Dark slate
   grey at rest so they read as active without shouting, red only on hover/focus to
   signal the destructive action at the point of intent, and the light disabled grey
   when the last tag/field can't be removed. Color lives here (not inline) so the
   :hover/:focus states can override the resting color. The \`.btn\` prefix lifts
   specificity above react-bootstrap's own \`.btn-link\` color rules. */
.btn.tetv-adv-remove-btn {
  color: #475569;
  transition: color 0.12s ease;
}
.btn.tetv-adv-remove-btn:not(:disabled):hover,
.btn.tetv-adv-remove-btn:not(:disabled):focus-visible {
  color: #dc3545;
}
.btn.tetv-adv-remove-btn:disabled,
.btn.tetv-adv-remove-btn.disabled {
  color: #cbd5e1;
}
`, "",{"version":3,"sources":["webpack://./src/components/search/advanced/AdvancedTopicQueryBuilder.css"],"names":[],"mappings":"AAAA;;;;;qEAKqE;AACrE;EACE,cAAc;EACd,4BAA4B;AAC9B;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB","sourcesContent":["/* Remove controls (field-row \"×\" and the tag \"Remove tag\" trashcan). Dark slate\n   grey at rest so they read as active without shouting, red only on hover/focus to\n   signal the destructive action at the point of intent, and the light disabled grey\n   when the last tag/field can't be removed. Color lives here (not inline) so the\n   :hover/:focus states can override the resting color. The `.btn` prefix lifts\n   specificity above react-bootstrap's own `.btn-link` color rules. */\n.btn.tetv-adv-remove-btn {\n  color: #475569;\n  transition: color 0.12s ease;\n}\n.btn.tetv-adv-remove-btn:not(:disabled):hover,\n.btn.tetv-adv-remove-btn:not(:disabled):focus-visible {\n  color: #dc3545;\n}\n.btn.tetv-adv-remove-btn:disabled,\n.btn.tetv-adv-remove-btn.disabled {\n  color: #cbd5e1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
